module.exports = __webpack_public_path__ + "static/img/sammlung-uni-jena.217eb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/sammlung-uni-jena.png
// module id = 5mZV
// module chunks = 0